import Alpine from "alpinejs";
import autoAdd from "./auto-add";
import { addOnCheck } from "./add-on/addOnCheck";
import { showAddOn } from "./add-on/showAddOn";
import { productForm } from "./product-template/form";
import productFunctions from "./product-template/functions";
import updateLetter from "./product-template/letter";
import updateForme from "./product-template/forme";
import LanguageSelector from "./language-selector/index";
import ViewportAnimate from "./viewport-animate/index";
import { giftcardShippingMsg } from "./giftcard/shippingMsg";
import giftcardMessage from "./giftcard-message/index";
import AddToCart from "./addtocart";
import CustomForm from "./custom-form";
import AnimateOnScroll from "./animate-on-scroll/index";
import LandingStickyBar from "./landing-sticky-bar/index";
import LandingGrid from "./landing-grid/index";
import Slider from "./swiper/index";
import CollectionHeroSwiper from "./collection-hero-swiper/index";
import MenuHoverImage from "./menu-hover-image/index";
import MobileMenuV2Positioner from "./mobile-menu-v2/index";
import AdvancedGridObserver from "./advanced-grid-observer/index";
import Countdown from "./countdown-timer/index";
import CustomSelect from "./custom-select/index";
import ProductFeaturesSlider from "./product-features-slider/index";
import LpCollaborationsSlider from "./lp-collaborations-slider/index";
import FeaturedResellersSlider from "./featured-resellers-slider/index";
import ResellerModal from "./reseller-modal/index";
import BoutiqueShowcaseSlider from "./boutique-showcase-slider/index";
import SyncImages from "./sync-images/index";
import "./g-product-list/index";
import { init as initReviewCarousel } from "./g-review-carousel/index";
import "./product-template-v2/index";
import "./mix-and-match/index";
import "./g-modal/g-modal";
import "./product-gallery/product-gallery";
import "./product-grid-v2/index";
import "./g-storytelling-video/index";
import CrossOriginDownload from "./cross-origin-download/index";
import "./g-product-list/index";

// start Alpine
Alpine.start();

// web components
window.customElements.define("module-addtocart", AddToCart);
window.customElements.define("module-custom-form", CustomForm);
window.customElements.define("custom-select", CustomSelect);
window.customElements.define("module-scroll-animate", AnimateOnScroll);
// window.customElements.define("landing-sticky-bar", LandingStickyBar);
window.customElements.define("landing-grid", LandingGrid);
window.customElements.define("module-swiper", Slider);
window.customElements.define("product-features-slider", ProductFeaturesSlider);
window.customElements.define("collection-hero-swiper", CollectionHeroSwiper);
window.customElements.define("lp-collaborations-slider", LpCollaborationsSlider);
window.customElements.define("featured-resellers-slider", FeaturedResellersSlider);
window.customElements.define("reseller-modal", ResellerModal);
window.customElements.define("boutique-showcase-slider", BoutiqueShowcaseSlider);
window.customElements.define("menu-hover-image", MenuHoverImage);
window.customElements.define("mobile-menu-v2-positioner", MobileMenuV2Positioner);
window.customElements.define("advanced-grid-observer", AdvancedGridObserver);
window.customElements.define("countdown-timer", Countdown);
window.customElements.define("sync-images", SyncImages);
window.customElements.define("cross-origin-download", CrossOriginDownload);
window.addEventListener("load", (event) => {
  autoAdd();
  initReviewCarousel();
  addOnCheck();
  showAddOn();
  LanguageSelector();
  ViewportAnimate();

  // product template

  productForm();
  productFunctions();
  updateLetter();
  updateForme();
  document.addEventListener("product-template-update", () => {
    initFunctions();
    addtocart();
    productForm();
    productFunctions();
    updateLetter();
    updateForme();
  });

  // giftcard message
  giftcardMessage();
  document.addEventListener("updated_cart", function (e) {
    giftcardMessage();
  });

  // giftcard

  giftcardShippingMsg();
  document.addEventListener("updated_cart", function (e) {
    giftcardShippingMsg();
  });
});
